// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer-module_SideDrawer_PoNBk","Open":"SideDrawer-module_Open_15FxE","Closed":"SideDrawer-module_Closed_2GNPP","Logo":"SideDrawer-module_Logo_3IFTZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawer.module.css
// module id = 99
// module chunks = 5